import { Axios, AxiosError, AxiosResponse } from 'axios'
import { RemoteConfig } from './remote.config'

export class OrganizationData {
	id: string;
	name: string;
	email: string;
	phone: string;

	constructor(id: string, name: string, email: string, phone: string) {
		this.id = id;
		this.name = name;
		this.email = email;
		this.phone = phone;
	}
}

export class OrganizationMembershipData {
	id: string;
	organization_id: string;
	user_id: string;
	permissions: number;

	constructor(id: string, org_id: string, user_id: string, permissions: number) {
		this.id = id;
		this.organization_id = org_id;
		this.user_id = user_id;
		this.permissions = permissions;
	}
}

export class MyOrganizationsData {
	memberships: OrganizationMembershipData[];
	orgs: OrganizationData[]

	constructor(memberships: OrganizationMembershipData[], orgs: OrganizationData[]) {
		this.memberships = memberships;
		this.orgs = orgs;
	}
}

export type MyOrganizationsCallback = (data?: MyOrganizationsData, resp?: AxiosResponse, err?: AxiosError) => void;

export const getMyOrganizations = (callback: MyOrganizationsCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/organizations/mine", RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: MyOrganizationsData = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export class CreateOrganizationData {
	name: string;
	email: string;
	phone: string;
	description: string;

	constructor(name: string, email: string, phone: string, description: string) {
		this.name = name;
		this.email = email;
		this.phone = phone;
		this.description = description;
	}
}

export type CreateOrganizationCallback = (data?: OrganizationData, resp?: AxiosResponse, err?: AxiosError) => void;

export const createOrganization = (data: CreateOrganizationData, callback: CreateOrganizationCallback) => {
	const client = new Axios();
	const url = new URL("/api/v0/organizations/", RemoteConfig.url);
	const result = client.post(url.toString(), JSON.stringify(data), {withCredentials: true, headers: {
		'Content-Type': 'application/json'
	  }}).then((resp) => {
		try {
			let data: OrganizationData = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}

export type GetOrganizationCallback = (data?: OrganizationData, resp?: AxiosResponse, err?: AxiosError) => void;

export const getOrganization = (id: string, callback: GetOrganizationCallback) => {
	const client = new Axios();
	const url = new URL(`/api/v0/organizations/${id}`, RemoteConfig.url);
	const result = client.get(url.toString(), {withCredentials:true}).then((resp) => {
		try {
			let data: OrganizationData = JSON.parse(resp.data)
			callback(data, resp)
		} catch {
			callback(undefined, resp)
		}
	})
}